<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo md:pt-10 md:pb-4 w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal mr-auto ml-auto p-5">
        <div
          class="success-container h-full pt-6"
        >
          <div class="text-left flex pl-6 pr-6">
            <div
              class="text-c24 font-c7 w-5/6"
            >
              Ajouter un service ou traitement
            </div>
            <div class="w-1/6 flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 mt-6 bg-white p-6 pb-12">

            <div>
              <div class="text-left text-c12">
                Catégorie*
              </div>
              <multiselect
                  :option="allCategorie"
                  width="40%"
                  :value-t="valueCategorie"
                  background="white"
                  class="mt-2"
                  @info="retourCategorie"
              />
            </div>

            <div class="text-left text-c12 mt-6">
              Intitulé *
            </div>
            <inputo
                class="mt-2"
                placeholder=""
                @info="retourNom"
            />

            <div v-if="valueCategorie === 'Traitement'" class="mt-6">
              <div class="text-left text-c12">
                Type de traitement
              </div>
              <multiselect
                  :option="sousCategorie"
                  width="40%"
                  :value-t="valueSous"
                  background="white"
                  class="mt-2"
                  @info="retourSous"
              />
            </div>

            <div class="text-left text-c12 mt-6">
              Fournisseur *
            </div>
            <multiselect
                v-if="optionFournisseur.length > 0"
                :option="optionFournisseur"
                width="40%"
                :value-t="valueFournisseur"
                background="white"
                class="mt-2"
                @info="retourFournisseur"
            />




<!--            <inputo-->
<!--                class="mt-2"-->
<!--                placeholder="Stock OHO"-->
<!--                @info="retourFournisseur"-->
<!--            />-->

            <div class="text-left text-c12 mt-6">
              Intitulé fournisseur *
            </div>
            <inputo
                class="mt-2"
                @info="retourIntitule"
            />


            <div class="flex  mt-6">
              <div class="w-1/2 mr-6">
                <div class="text-left text-c12">
                  Prix
                </div>
                <inputo
                    class="mt-2"
                    type="number"
                    @info="retourPrix"
                />
              </div>

              <div v-if="allPrices.length > 0" class="w-1/2">
                <div class="text-left text-c12">
                  Catégorie de prix*
                </div>
                <multiselect
                    :option="allPrices"
                    width="18%"
                    :value-t="valueType"
                    background="white"
                    class="mt-2"
                    @info="retourType"
                />
              </div>
            </div>

            <div class="flex">
              <div class="w-full">
                <div class="text-left text-c12 mt-8">
                  Observation
                </div>
                <textare
                    class="mt-2"
                    background="#F2F5F9"
                    color="#606060"
                    radius="5px"
                    @info="retourNote"
                />
              </div>
            </div>


            <div
              v-if="error !== null"
              class="mt-6 text-red"
            >
              {{ error }}
            </div>
          </div>

          <div class="flex">
            <div class="w-full">
              <buton
                label="Enregistrer"
                radius="0px"
                :charge="charge"
                height="55px"
                @oga="continuer"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import buton from '../helper/add/button'
import ic_agence from '../../assets/icons/agenceGray.svg'
import fermer from '../../assets/icons/fermer.svg'
import inputo from '../helper/form/input'
import textare from '../helper/form/textarea'
import multiselect from '../helper/form/multiselect'
import http from "../../plugins/https"
import apiroutes from "../../router/api-routes"

export default {
  name: 'Success',
  components: { PopupBase, buton, inputo, multiselect, textare },
  props: {
    activation: {
      type: Boolean,
      default: false
    },
    donne: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      donnes: null,
      wantToMakeOffer: false,
      icons: {
        ic_agence,
        fermer
      },
      prix: '',
      nom: '',
      error: null,
      charge: false,
      valueType: '',
      allCategorie: ['Service', 'Réparation', 'Traitement'],
      valueCategorie: 'Service',
      sousCategorie: ['Traitement de masse', 'Traitement de surface', 'Traitement de seconde vente'],
      valueSous: '',
      optionFournisseur: [],
      valueFournisseur: '',
      allPrices:[],
      temoinPrice: [],
      fournisseur: '',
      intitule: '',
      allSupplier: []
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
    this.allPrix()
    this.allFournisseur()
  },

  methods: {
    fermer () {
      this.$emit('oga', false)
    },

    allPrix () {
      http.get(apiroutes.baseURL + apiroutes.allPrice)
          .then(response => {
            const all = response.reverse()
            let tab = []
            for (let item in all) {
              tab.push(all[item].label)
            }
            this.allPrices = tab
            this.temoinPrice = all
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
          })
    },

    allFournisseur () {
      http.get(apiroutes.baseURL + apiroutes.allSupplier + '?type=JOB')
          .then(response => {
            this.allSupplier = response.reverse()
            let tab = []
            for (let item in this.allSupplier) {
              tab.push(this.allSupplier[item].name)
            }
            this.valueFournisseur = tab[0]
            this.optionFournisseur = tab
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
          })
    },

    continuer () {
      this.charge = true
      this.error = null
      if (this.intitule.length > 0 && this.prix > 0 && this.valueType !== '' && this.nom.length > 0) {
        const body = {
          name: this.nom,
          price: this.prix,
          type: 'SERVICE',
          meta: {
            intituleFournisseur: this.intitule,
            fournisseur: this.valueFournisseur
          }
        }

        if (this.valueCategorie === this.allCategorie[0]) {
          body.prestationType = 'SERVICE'
        }

        if (this.valueCategorie === this.allCategorie[1]) {
          body.prestationType = 'REPARATION'
        }

        if (this.valueCategorie === this.allCategorie[2]){
          body.type = 'TREATMENT'
          if (this.valueSous === this.sousCategorie[0]) {
            body.treatmentCategory = 'MASS'
          }
          if (this.valueSous === this.sousCategorie[1]) {
            body.treatmentCategory = 'AREA'
          }
          if (this.valueSous === this.sousCategorie[2]) {
            body.treatmentCategory = 'SECOND_SELL'
          }
        }

        this.save(body)
      } else {
        this.charge = false
        this.error = 'Veuillez remplir les champs pour continuer'
      }
    },

    save (donne) {
      console.log(donne)
      this.charge = true
      http.post(apiroutes.baseURL + apiroutes.createProduct, donne)
          .then(response => {
            this.savePrice(response.id)
          })
          .catch(error => {
            this.charge = false
            console.log(error)

            if (error.data.message === 'Please create principal stock agency'){
              this.error = "L'agence de Stock n'existe pas. Veuillez l'ajouter et ressayer"
            } else {
              this.error = "Une erreur s'est produite. Veuillez ressayer"
            }
          })
    },

    savePrice (id) {
      let tab =[]
      for (let i in this.temoinPrice) {
        if (this.valueType === this.temoinPrice[i].label) {
          let obj = {
            amount: this.prix,
            product: id,
            category: this.temoinPrice[i].id
          }
          tab.push(obj)
        }
      }

      http.post(apiroutes.baseURL + apiroutes.saveProductPrice, {prices: tab})
          .then(response => {
            this.$emit('oga', false)
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    retourSous (answer) {
      this.valueSous = answer
    },


    retourNote (answer) {
      this.note = answer
    },

    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    },

    retourNom (answer) {
      this.nom = answer
    },

    retourIntitule (answer) {
      this.intitule = answer
    },

    retourFournisseur (answer) {
      this.fournisseur = answer
    },

    retourType (answer) {
      this.valueType = answer
    },

    retourPrix (answer) {
      this.prix = parseInt(answer)
    },

    retourCategorie (answer) {
      this.valueCategorie = answer
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 44%;
    }

    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: #F5F5F5;
      height: auto;
      margin: auto;
      border-radius: 12px;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
